<template>
  <CardSlider :breakpoints="breakpoints" :heading="heading">
    <LinkField
      v-for="(item, index) in links"
      :key="index"
      v-bind="item.cta[0]"
      class="group px-6"
      :no-tracking="true"
      trackingName="largeSquare"
      typeName="largeSquare"
    >
      <div class="overflow-hidden">
        <CldnImg
          v-if="item.image[0]"
          :src="item.image[0].url"
          :alt="item.image[0].title"
          :ratio="4 / 3"
          class="group-hover:scale-105 transition-transform duration-700 transform border-none max-w-[180px] max-h-[180px] w-full"
          sizes="100px lg:180px"
        />
      </div>
      <div
        class="fluid-xs leading-tightest font-medium md:mt-6 mt-3 text-center uppercase"
        v-html="item.cta[0].text"
      ></div>
    </LinkField>
  </CardSlider>
</template>

<script>
import CldnImg from '@/components/CldnImg';
import FixedAspect from '@/components/common/FixedAspect';
import LinkField from '@/components/common/LinkField';
import CardSlider from '@/components/common/CardSlider';

export default defineNuxtComponent({
  components: {
    CardSlider,
    FixedAspect,
    CldnImg,
    LinkField,
  },
  props: {
    heading: {
      type: String,
      default: null,
    },
    links: {
      type: Array,
      default: () => [],
    },
    blockPosition: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      breakpoints: [
        {
          minWindowWidth: 0,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
        {
          minWindowWidth: 640,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
        {
          minWindowWidth: 768,
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      ],
    };
  },

  methods: {
    gtmData(payload, index) {
      return {
        promotion_id: payload.cta.element?.uri,
        promotion_name: [this.$route?.name, payload.cta.text].join(' / '),
        creative_name: 'LinksDisplay_LargeRounded',
        creative_slot: [this.$route?.name, this.blockPosition + 1, index + 1].join(' / '),
      };
    },
  },
});
</script>
